import * as React from 'react'

import { Button } from '../../../../main/components/button'
import { SpecificChartFunctionality, TIMEFRAME } from '../../../../main/constants'
import { Instrument } from '../../../../main/types'
import { FuturesForexCryptoTimeframeBar } from '../../../shared/components/FuturesForexCryptoTimeframeBar'
import { PageType, TimeFrames } from '../../types'

function getCurrencyLongName(currency: string) {
  switch (currency.toLowerCase()) {
    case 'btc':
      return 'Bitcoin'
    case 'ltc':
      return 'Litecoin'
    case 'eth':
      return 'Ethereum'
    case 'xrp':
      return 'Ripple'
    case 'bch':
      return 'Bitcoin Cash'
    case 'usd':
      return 'Dollar'
    case 'eur':
      return 'Euro'
  }
  return currency
}

interface MenuProps<Key> {
  isDetailOpen?: boolean
  activePage: PageType
  timeframes: TimeFrames<Key>
  company?: string
  onTimeframeChange?: (timeframe: TIMEFRAME) => void
  onDateRangeChange?: (dateRange: string | undefined) => void
}

export default function Menu<Key extends string>({
  isDetailOpen,
  activePage,
  timeframes,
  company,
  onTimeframeChange,
  onDateRangeChange,
}: MenuProps<Key>) {
  return (
    <div className="flex h-12 items-center justify-between py-2.5">
      <div className="flex space-x-px font-sans">
        <Button as="a" href="/crypto.ashx" active={activePage === PageType.Quotes} theme="chipTransparent">
          Quotes
        </Button>
        <Button
          as="a"
          href="/crypto_performance.ashx"
          theme="chipTransparent"
          active={activePage === PageType.Performance}
        >
          Performance
        </Button>
        <Button as="a" href="/crypto_charts.ashx" theme="chipTransparent" active={activePage === PageType.Charts}>
          Charts
        </Button>
      </div>
      <div className="flex w-64 justify-end space-x-px font-sans xl:w-96">
        {activePage === PageType.Charts ? (
          <FuturesForexCryptoTimeframeBar
            isDetail={isDetailOpen}
            title="Crypto"
            group={company ? `${company?.split('/').map(getCurrencyLongName).join(' / ')} ${company}` : undefined}
            onTimeframeChange={onTimeframeChange}
            onDateRangeChange={onDateRangeChange}
            specificChartFunctionality={SpecificChartFunctionality.cryptoPage}
            instrument={Instrument.Crypto}
          />
        ) : (
          timeframes.timeframes.map((timeframe) => (
            <Button
              key={timeframe.key}
              as="a"
              {...{ href: timeframes.link?.(timeframe.key as Key) }}
              theme="chipTransparent"
              padding="small"
              active={timeframes.active === timeframe.key}
              onClick={(ev: React.MouseEvent<HTMLAnchorElement>) => timeframes.onClick?.(timeframe.key as Key, ev)}
              title={timeframe.title}
            >
              {timeframe.value}
            </Button>
          ))
        )}
      </div>
    </div>
  )
}
